import React, { useEffect } from "react";
import "./CustomizationChooserSheet.css";

const productKey = (product) => product?.id || product?.skuCode || product?.name;

const formatOptions = (item) => {
  const parts = [];

  if (item?.variantTitle) {
    parts.push(item.variantTitle);
  }

  (item?.selectedOptions || []).forEach((option) => {
    const title = option?.title || option?.name;
    if (title) {
      parts.push(title);
    }
  });

  return parts.length ? parts.join(", ") : "Default customisation";
};

const getTagIcon = (product) => {
  const tags = Array.isArray(product?.tags) ? product.tags : [];
  const hasEggTag = tags.some((tag) => tag?.name?.toLowerCase().includes("egg"));
  const hasNonVegTag = tags.some((tag) => {
    const name = tag?.name?.toLowerCase() || "";
    return name.includes("non") && name.includes("veg");
  });

  if (hasEggTag && hasNonVegTag) {
    return "/EggTag.png";
  }

  const iconTag = tags.find((tag) => tag?.tagIcon?.fullPath);
  return iconTag?.tagIcon?.fullPath || null;
};

export default function CustomizationChooserSheet({
  product,
  cartItems,
  onClose,
  onAddNew,
  onEdit,
  onUpdateQuantity,
}) {
  useEffect(() => {
    const body = document.body;
    const previousOverflow = body.style.overflow;
    body.style.overflow = "hidden";

    return () => {
      body.style.overflow = previousOverflow;
    };
  }, []);

  const tagIcon = getTagIcon(product);
  const visibleItems = (cartItems || []).filter((item) => item?.productId === productKey(product));

  if (!product || visibleItems.length === 0) {
    return null;
  }

  return (
    <div className="customization-chooser-overlay" onClick={onClose}>
      <button className="customization-chooser-close" onClick={onClose} aria-label="Close customisation chooser">
        ×
      </button>
      <div className="customization-chooser-sheet" onClick={(event) => event.stopPropagation()}>
        <div className="customization-chooser-handle" />
        <h3 className="customization-chooser-title">Choose customisation</h3>

        <div className="customization-chooser-list">
          {visibleItems.map((item) => (
            <div className="customization-chooser-row" key={item.id}>
              <div className="customization-chooser-main">
                {tagIcon && (
                  <img className="customization-chooser-tag" src={tagIcon} alt="" aria-hidden="true" />
                )}
                <div className="customization-chooser-copy">
                  <div className="customization-chooser-name-row">
                    <strong>{product.name}</strong>
                  </div>
                  <p>{formatOptions(item)}</p>
                  <button className="customization-chooser-edit" onClick={() => onEdit(item)}>
                    Edit
                  </button>
                </div>
              </div>

              <div className="customization-chooser-actions">
                <div className="customization-chooser-qty">
                  <button
                    onClick={() => onUpdateQuantity(item.id, -1)}
                    aria-label={`Remove one ${product.name}`}
                  >
                    −
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    onClick={() => onUpdateQuantity(item.id, 1)}
                    aria-label={`Add one ${product.name}`}
                  >
                    +
                  </button>
                </div>
                <strong>₹{Math.round(Number(item.unitPrice || 0) * Number(item.quantity || 0))}</strong>
              </div>
            </div>
          ))}
        </div>

        <button className="customization-chooser-add-new" onClick={onAddNew}>
          + Add new customisation
        </button>
      </div>
    </div>
  );
}
